import { BehaviorSubject, Observable, ReplaySubject, filter, firstValueFrom, timer } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { ISessionInfo } from '@core/base/session-base.types';
import { coreDevice } from "@core/r2";

export abstract class SessionBase {
    public authState$: BehaviorSubject<boolean | undefined> = new BehaviorSubject<boolean | undefined>(undefined);

    protected sessionInfo!: ISessionInfo;
    protected _sessionInfo$: ReplaySubject<ISessionInfo> = new ReplaySubject<ISessionInfo>(1);

    private initState: boolean = false;
    private readonly BLANK_ID: string = '00000000-0000-0000-0000-000000000000';

    constructor() {
        this.init();
    }

    get sessionInfo$(): Observable<ISessionInfo> {
        return this._sessionInfo$.asObservable();
    }

    public getSession(): ISessionInfo {
        return this.sessionInfo;
    }

    public abstract check(): Promise<boolean>;

    public abstract processCallback(): Promise<boolean | void>;

    public abstract login(userHint?: string, ...args: unknown[]): Promise<string>;

    public abstract logout(): Promise<unknown>;

    protected async waitInit(): Promise<void> {
        if (!this.initState) {
            await firstValueFrom(
                timer(0, 100).pipe(filter(() => this.initState))
            );
        }
    }

    protected async init() {
        if (this.initState) return;

        if (!this.sessionInfo) {
            this.sessionInfo = {
                device_hash: <string>localStorage.getItem('device_hash'),
                session_id: <string>localStorage.getItem('session_id'),
            };

            if (!this.sessionInfo.device_hash || this.sessionInfo.device_hash.length == 0) {
                this.sessionInfo.device_hash = await coreDevice.Info.GetHash();
                localStorage.setItem('device_hash', this.sessionInfo.device_hash);
            }

            if (!this.sessionInfo.session_id || this.sessionInfo.session_id == this.BLANK_ID) {
                this.sessionInfo.session_id = uuidv4();
                localStorage.setItem('session_id', this.sessionInfo.session_id);
            }
        }

        this._sessionInfo$.next(this.sessionInfo);
        this.initState = true;
    }
}
